<template>
	<div class="list list--settings list-settings">
		<table-list
			:items="settings"
			:loading="isLoading"
			:noHover="true"
		>
			<template slot="header">
				<span
					:class="`settings-header-item settings-header-item--${key}`"
					:key="key"
					v-for="(col, key) in columns"
				>
					<component :is="orderBy[key] ? 'a' : 'span'" @click="sort(key)"> {{ col }}</component>
					<ion-icon :name="query.order == 'asc' ? `caret-up` : `caret-down`" v-if="orderBy[key] && orderBy[key] == query.orderBy"></ion-icon>
				</span>
			</template>

			<template slot="item" slot-scope="{ item }">
				<div
					:class="`settings-item settings-item--${key} settings-item--${item['status']}`"
					:key="`item_${key}`"
					v-for="(col, key) in columns"
					v-html="transform(key, get(item, key))"
				>
				</div>
			</template>

		</table-list>
	</div>
</template>

<script>
import { format, parseISO, formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns'
import { get } from 'lodash'

import TableList from '@/components/TableList'

export default {
	name: 'ListSettings',
	components: {
		TableList,
	},
	props: {
		settings: {
			type: Array,
			default: () =>([]),
		},
	},
	data: () => ({
		columns: {
			key: 'Key',
			value: 'Value',
		},
		order: 'asc',
	}),
	computed: {
		isLoading() {
			return this.$store.getters['misc/loading']
		},
		query() {
			return this.$route.query
		},
		orderBy() {
			let orderBy = {
				// key: 'Key',
				// value: 'Value',
				// nameEmail: 'firstName',
				// dateCreated: 'dateCreated',
				// organization: 'organization.name',
				// 'settings.salesforceId': 'salesforceId',
				// dateLogin: 'dateLogin',
				// status: 'status',
			}

			return orderBy
		},
		locationId() {
			return this.$route.params.locationId
		},
	},
	methods: {
		transform(key, value) {
			switch(key) {
				case 'dateCreated':
				case 'dateModified':
					try {
						value = `${format(parseISO(value), 'PPp')}`
					} catch (error) {
						try {
							value = `${format(value, 'PPp')}`
						} catch (error) {
							console.warn(error)
						}
					}
					return value
				case 'status':
					return FormStatus[value]
			}
			return value
		},
		sort(key) {

		},
		get,
	}
}
</script>

<style scoped lang="scss">
.list-settings {
	::v-deep .table-list {
		&__item,
		&__header {
			border-bottom: 1px solid modules.color_('border', 'light');
			display: grid;
			grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr);

			@include modules.media-query('phone') {
				grid-template-columns: minmax(50%, 1fr) minmax(50%, 1fr);
			}
		}

		.list-settings__app-list {
			list-style-type: none;
			margin: 0;
			padding: 0;
		}
	}

	.settings-header-item {
		@include modules.fontSize(14px);
		align-items: center;
		display: flex;
		font-weight: 600;
		padding: 1em 1.5em;

		@include modules.media-query('phone') {
			padding: 0.5em 1em;
		}
	}

	.settings-item {
		color: modules.color_('text', 'dark');
		font-weight: 500;
		overflow-wrap: break-word;
		padding: 1.5em;
		text-decoration: none;

		@include modules.media-query('phone') {
			@include modules.fontSize(15px);
			padding: 0.5em 1em;
		}

		&--pending {
			&.settings-item--status {
				color: modules.color_('alert', 'warn');
			}
		}

		&--removed {
			opacity: 0.7;

			&.settings-item--status {
				color: modules.color_('alert', 'error')
			}
		}
	}
}
</style>
